import React, { useContext } from 'react';
import { FilterBarContext, FilterFieldName } from '../FilterBarContext';
import { LocationSelect } from '@/modules/locations/components/LocationSelect';
import { LocationModel } from '@/modules/locations/types/LocationModel';

interface FromLocationFilterProps {
  label: string;
}

const FromLocationFilter: React.FC<FromLocationFilterProps> = ({ label }) => {
  const { setFilterValue, filterValues } = useContext(FilterBarContext);

  function onLocationSelected(location: LocationModel | null) {
    if (location) {
      setFilterValue(FilterFieldName.fromLocationId, location.dto.id, location.dto.name);
    } else {
      setFilterValue(FilterFieldName.fromLocationId, undefined);
    }
  }

  return (
    <LocationSelect
      label={label}
      selectedLocationId={filterValues.fromLocationId ? Number.parseInt(filterValues.fromLocationId.toString()) : undefined}
      onSelected={onLocationSelected}
    />
  );
};

export default FromLocationFilter;
